<template>
  <div>
    <popover
      v-model="isExpanded"
      placement="bottom-start"
    >
      <picker-input
        slot="reference"
        :size="size"
        :clearable="clearable && !isExpanded"
        :disabled="disabled"
        :hide-picker-icon="hidePickerIcon"
        :range-separator="rangeSeparator"
        :active="isExpanded"
        :value="value"
        :label-format="labelFormat"
        :start-placeholder="startPlaceholder"
        :end-placeholder="endPlaceholder"
        @clear="handleClear"
      />
      <picker-pane
        v-if="renderPane"
        :value="vProxy"
        :active="isExpanded"
        @date-time-change="handleDateTimeChange"
        @clear="handleClear"
      />
    </popover>
  </div>
</template>

<script>
import PickerInput from './PickerInput.vue'
import PickerPane from './PickerPane.vue'
import Popover from '../popover'
import moment from 'moment-mini'

export default {
  name: 'KDateTimePicker',
  components: {
    PickerInput,
    Popover,
    PickerPane,
  },
  props: {
    // 双向绑定选中值
    value: {
      type: Array,
      default: () => [],
    },
    // 输出值的格式，如果不传，则输出为moment[]
    valueFormat: {
      type: String,
      default: '',
    },
    // input 显示格式
    labelFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm',
    },
    // 开始提示文字
    startPlaceholder: {
      type: String,
      default: '开始日期',
    },
    // 结束提示文字
    endPlaceholder: {
      type: String,
      default: '结束日期',
    },
    // 尺寸
    size: {
      validator: (val) =>
        ['large', 'normal', 'small', 'mini'].indexOf(val) !== -1,
      type: String,
      default: 'normal',
    },
    // 是否可以清空
    clearable: {
      type: Boolean,
      default: true,
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否隐藏图标
    hidePickerIcon: {
      type: Boolean,
      default: false,
    },
    // 连接符
    rangeSeparator: {
      type: String,
      default: '-',
    },
  },
  data() {
    return {
      isExpanded: false,
      renderPane: false,
    }
  },
  computed: {
    vProxy() {
      return this.value.map(item => {
        if (moment(item).isValid()) {
          return moment(item)
        }
        return null
      })
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.initFormat()
      },
    },
    isExpanded: {
      immediate: true,
      handler(val, oldV) {
        if (oldV) {
          this.emitInput([...this.value])
          setTimeout(() => {
              this.renderPane = false
          }, 200)
        } else {
          this.renderPane = true
        }
      },
    },
  },
  mounted() {
    this.handleDateTimeChange(this.value)
  },
  methods: {
    handleClear() {
      this.emitInput([])
    },
    handleDateTimeChange(val) {
      this.emitInput(val)
    },
    emitInput(val) {
      this.$emit('input', val.sort((fir, sec) => fir.valueOf() - sec.valueOf()).map(item => {
        if (this.valueFormat) {
          return item && item.format && item.format(this.valueFormat)
        }
        return item && item.valueOf && item.valueOf()
      }))
      this.isExpanded = false
    },
    initFormat() {
      if (this.valueFormat) {
        const [valS, valE] = this.vProxy
        const sStr = valS && valS.format && valS.format(this.valueFormat)
        const eStr = valE && valE.format && valE.format(this.valueFormat)
        if (sStr !== this.value[0] || eStr !== this.value[1]) {
          this.emitInput(this.vProxy)
        }
      } else if (typeof this.value[0] === 'string') {
        this.emitInput(this.vProxy)
      }
    },
  },

}
</script>
